void (function () {
  /* Print Page */
  const pagePrintElement = document.querySelector('.js-print-trigger')

  pagePrintElement &&
    pagePrintElement.addEventListener('click', () => {
      window.print()
    })

  /* Toggle sharing menu */
  const sharingMenuToggle = document.querySelector('.js-sharing-menu-toggle')

  if (sharingMenuToggle) {
    const sharingMenu = document.querySelector('.js-sharing-menu')

    document.addEventListener('click', event => {
      const isSharingMenuToggle = event.target.closest(
        '.js-sharing-menu-toggle'
      )
      const issharingMenu = event.target.closest('.js-sharing-menu')
      const isMenuLink = event.target.closest('.js-sharing-menu-link')

      if (isSharingMenuToggle) {
        if (sharingMenuToggle.classList.contains('is-open')) {
          sharingMenuToggle.classList.add('is-closed')
          sharingMenu.classList.add('is-closed')
          sharingMenuToggle.classList.remove('is-open')
          sharingMenu.classList.remove('is-open')
        } else {
          sharingMenuToggle.classList.add('is-open')
          sharingMenu.classList.add('is-open')
          sharingMenuToggle.classList.remove('is-closed')
          sharingMenu.classList.remove('is-closed')
        }
      } else {
        if (
          (!issharingMenu && sharingMenuToggle.classList.contains('is-open')) ||
          isMenuLink
        ) {
          sharingMenuToggle.classList.add('is-closed')
          sharingMenu.classList.add('is-closed')
          sharingMenuToggle.classList.remove('is-open')
          sharingMenu.classList.remove('is-open')
        }
      }
    })
  }
})()
